import Footer from "../../components/main/Footer"
import Basket from "../../components/organisms/Basket"
import { Topbar } from "../../components/organisms/Topbar"
import { ServicePage } from "../../digital-journey/ServicePage"
import CreateOrderButton from "./components/CreateOrderButton"
import { SimulationInputFormWrapper } from "./components/SimulationInputFormWrapper"
import useSimulationPage from "./hooks/useSimulationPage"
import "./styles.css"
import React from "react"
import { Col, Container, Row, Spinner } from "react-bootstrap"

export default function Simulation({ tunnelData, history }) {
  const {
    createOrder,
    isLoadingCreateOrder,
    showBasket,
    showCreateOrderButton,
    packToTunnelData,
    product,
    setProduct,
    handleSimulationSubmit,
    isLoading,
    selectedPack,
    quantity,
    packContext
  } = useSimulationPage()

  React.useEffect(() => {
    // need to handle this product state passed as props in component <CreateOrderButton/> to know if Validation button should be disabled or not.
    if (tunnelData?.data?.order?.products && product === null) {
      setProduct(tunnelData?.data?.order?.products[0])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Container fluid>
      <Row noGutters>
        <Topbar displayToggleButton={true} tunnelData={packToTunnelData(selectedPack)} history={history} />
        <Col className="main-block">
          <SimulationInputFormWrapper
            tunnelData={tunnelData}
            simulationSubmit={handleSimulationSubmit}
            setProduct={setProduct}
          />

          <>
            {(isLoading || isLoadingCreateOrder) && (
              <span className="spinner-box">
                <Spinner animation="border" className="spinner" />
              </span>
            )}
            <ServicePage />
          </>
        </Col>
        {showBasket && (
          <Col className="aside-block d-none d-md-none d-lg-block" lg={4}>
            <Basket
              tunnelData={packToTunnelData(selectedPack)}
              quantity={quantity}
              createOrderButton={
                <CreateOrderButton
                  packContext={packContext}
                  isLoading={isLoading}
                  product={product}
                  createOrder={createOrder}
                  showCreateOrderButton={showCreateOrderButton}
                />
              }
            />
          </Col>
        )}
        <Col lg={12} className="footer">
          <Container>
            <Footer tunnelData={tunnelData} infosAndClientPageDisplay={true} />
          </Container>
        </Col>
      </Row>
    </Container>
  )
}
